export default {"src":"/_next/static/media/double-bed.d2c37ccc.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};